import { Button, Typography } from '@material-ui/core';
import React, { useState } from 'react';
import ContactServices from '../../../services/ContactServices';
import { makeStyles } from '@material-ui/core/styles';
import Swal from 'sweetalert2';
import cluo from '../../../assets/images/contacto/cluo.png';


const styles = makeStyles((theme) => ({
  root: {
    width: "100%"
  },
  comtainer: {
    width: '98%',
    maxWidth: '800px',
    boxSizing: 'border-box',
    [theme.breakpoints.down('sm')]: {
        maxWidth: '100%',
    },
  },

   botonEnviar: {
    color: '#FFFFFF',
    backgroundColor: '#912b2b',
    marginBottom: '20px',
    '&:hover': {
      backgroundColor: '#b73d3d',
    }
  }
}));



const FormularioPostularStart = () => {
  const classes = styles();

  const [nombres, setNombres] = useState("");
  const [telefono, setTelefono] = useState("");
  const [email, setEmail] = useState("");
  const [mensaje, setMensaje] = useState("");

  const [nombresErr, setNombresErr] = useState({});
  const [telefonoErr, setTelefonoErr] = useState({});
  const [emailErr, setEmailErr] = useState({});
  const [mensajeErr, setMensajeErr] = useState({});

  const onSubmit = (e) => {
    e.preventDefault();
    const isValid = formValidation();
    if (isValid) {
      const dataForm = {
        Nombres: nombres,
        Telefono: parseInt(telefono),
        Email: email,
        Mensaje: mensaje
      };

      sendEmail(dataForm)
        .then(() => {
          setNombres("");
          setTelefono("");
          setEmail("");
          setMensaje("");
        })
        .catch(error => {
          console.error("Error en onSubmit:", error);
        });
    }
  };

  const formValidation = () => {
    const fvNombresErr = {};
    const fvTelefonoErr = {};
    const fvEmailErr = {};
    const fvMensajeErr = {};
    let isValid = true;

    if (nombres.trim().length < 1) {
      fvNombresErr.nombresShort = "Ingrese nombres y apellidos";
      isValid = false;
    }

    if (telefono.trim().length < 1) {
      fvTelefonoErr.telefonoShort = "Ingrese número de teléfono";
      isValid = false;
    }

    if (telefono.length >= 1 && telefono.length < 9) {
      fvTelefonoErr.telefonoCorto = "Número de teléfono inválido";
      isValid = false;
    }

    if (email.trim().length < 1) {
      fvEmailErr.emailShort = "Ingrese correo electrónico";
      isValid = false;
    }

    if (mensaje.trim().length < 1) {
      fvMensajeErr.mensajeShort = "Responda a la pregunta por favor";
      isValid = false;
    }

    setNombresErr(fvNombresErr);
    setTelefonoErr(fvTelefonoErr);
    setEmailErr(fvEmailErr);
    setMensajeErr(fvMensajeErr);
    return isValid;
  };

  const sendEmail = async (userdata) => {
    try {
      const response = await ContactServices.sendContactEmail(userdata);
      let parsedData = typeof response.data === 'string' ? JSON.parse(response.data) : response.data;

      if (parsedData.body) {
        const bodyParsed = JSON.parse(parsedData.body);
        if (bodyParsed.statusCode === 200) {
          Swal.fire({
            imageUrl: cluo,
            title: bodyParsed.message || "Correo enviado exitosamente",
            confirmButtonColor: 'green',
          });
          return;
        } else {
          Swal.fire({
            imageUrl: cluo,
            title: bodyParsed.message || "Error al enviar correo",
            confirmButtonColor: 'red',
          });
          return;
        }
      }

      if (parsedData.statusCode === 200) {
        Swal.fire({
          imageUrl: cluo,
          title: parsedData.message || "Correo enviado exitosamente",
          confirmButtonColor: 'green',
        });
      } else {
        Swal.fire({
          imageUrl: cluo,
          title: parsedData.message || "Error al enviar correo",
          confirmButtonColor: 'red',
        });
      }

    } catch (error) {
      Swal.fire({
        imageUrl: cluo,
        title: "Lo sentimos, no logramos enviar el correo",
        confirmButtonColor: 'red',
      });
    }
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', marginBottom: '6rem' }}>
      
        <div style={{ textAlign: 'center', marginBottom: '30px', maxWidth: '800px',}}>
            <Typography variant="h4" style={{ fontFamily: 'Raleway', color: '#000000', fontWeight: 'bold', marginBottom: '10px' }}>
                ¿Te animas a <span style={{color: '#912b2b'}}>participar</span>?
            </Typography>
            <Typography style={{ fontFamily: 'Raleway', color: '#000000', fontSize: '1.1rem', marginTop:'30px' }}>
                Postúlate en el siguiente formulario y sé parte de esta experiencia increíble.
            </Typography>
        </div>
      
      
      
      
      <form 
        onSubmit={onSubmit} 
        style={{ 
          width: '50%', 
          display: 'flex', 
          justifyContent: 'center',
          maxWidth: '800px',
        }}
        className="formulario-postular-form"
      >
        <div className={classes.comtainer} style={{ display: 'flex', flexDirection: 'column', backgroundColor: '#232F3E', padding: '2rem', borderRadius: '10px',  }}>
          
          <div style={{ marginBottom: '10px', marginTop: '20px' }}>
            <Typography style={{ color: '#FFFFFF', marginBottom: '10px', fontFamily: 'Raleway' }}>Nombres y Apellidos:</Typography>
                <input
                type="text"
                value={nombres}
                onChange={(e) => setNombres(e.target.value)}
                className={classes.root}
                />
            {Object.values(nombresErr).map((msg, i) => (
              <Typography key={i} style={{ color: "red" }}>{msg}</Typography>
            ))}
          </div>

          <div style={{ marginBottom: '20px', marginTop: '10px' }}>
            <Typography style={{ color: '#FFFFFF', marginBottom: '10px',  fontFamily: 'Raleway' }}>Celular:</Typography>
            <input
              type="number"
              value={telefono}
              onChange={(e) => setTelefono(e.target.value)}
              className={classes.root}
            />
            {Object.values(telefonoErr).map((msg, i) => (
              <Typography key={i} style={{ color: "red" }}>{msg}</Typography>
            ))}
          </div>

          <div style={{ marginBottom: '20px' }}>
            <Typography style={{ color: '#FFFFFF', marginBottom: '10px',  fontFamily: 'Raleway'}}>Correo electrónico:</Typography>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className={classes.root}
            />
            {Object.values(emailErr).map((msg, i) => (
              <Typography key={i} style={{ color: "red" }}>{msg}</Typography>
            ))}
          </div>

          <div style={{ marginBottom: '30px' }}>
            <Typography style={{ color: '#FFFFFF', marginBottom: '10px', fontFamily: 'Raleway' }}>¿Por qué deseas postular?</Typography>
            <textarea
              value={mensaje}
              onChange={(e) => setMensaje(e.target.value)}
              className={classes.root}
              style={{ height: '150px', resize: 'none' }}
            />
            {Object.values(mensajeErr).map((msg, i) => (
              <Typography key={i} style={{ color: "red" }}>{msg}</Typography>
            ))}
          </div>

        <Button
            className={`${classes.root} ${classes.botonEnviar}`}
            type="submit"
            >
            Enviar
        </Button>

        </div>
      </form>
    </div>
  );
};

export default FormularioPostularStart;
